module.exports = __webpack_public_path__ + "static/media/RR-Glass-1.688e227a.JPG";